<template>
  <DxPopup
    :visible="show"
    :show-title="true"
    :show-close-button="true"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    width="400"
    height="auto"
    :title="title"
    @hiding="$emit('close')"
  >
    <div class="confirm-body">{{ message }}</div>
    <div class="confirm-actions">
      <SmagriaButton
        :label="$t('ok')"
        customClass="primary"
        @click="handleConfirm"
      />
      <SmagriaButton
        :label="$t('common.cancel')"
        customClass="secondary border"
        @click="handleClose"
      />
    </div>
  </DxPopup>
</template>

<script>
import DxPopup from "devextreme-vue/popup";
import SmagriaButton from "@/components/Common/SmagriaButton.vue";

export default {
  name: "ConfirmDxPopup",
  components: { DxPopup, SmagriaButton },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Confirm",
    },
    message: {
      type: String,
      default: "Are you sure?",
    },
  },
  methods: {
    handleConfirm() {
      this.$emit("confirm");
    },
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.confirm-body {
  padding: 16px 0;
}

.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 8px;
}
</style>
